
import React from 'react';
import { MapPin } from 'lucide-react';

const MapSection = () => {
  return (
    <section className="py-12 bg-gray-50">
      <div className="container">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center">Hier vind je ons</h2>
        <div className="h-[400px] rounded-lg overflow-hidden shadow-md">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2504.953046541136!2d4.030823651747896!3d51.09374644746458!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c3a056a2915ddd%3A0x7dea3704b539780b!2sMoorselbaan+391%2C+9300+Aalst!5e0!3m2!1sen!2sbe!4v1713994113251!5m2!1sen!2sbe" 
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen={true} 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title="Afsprakenmaker.be locatie in Aalst"
            className="w-full h-full"
            aria-label="Google Maps locatie van Afsprakenmaker.be in Aalst"
          ></iframe>
        </div>
        <div className="mt-4 text-center">
          <a 
            href="https://www.google.com/maps/dir//Moorselbaan+391,+9300+Aalst/@51.0937464,4.0308237,17z/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-brand-blue hover:underline"
            aria-label="Open routebeschrijving in Google Maps"
          >
            <MapPin size={16} aria-hidden="true" /> Routebeschrijving
          </a>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
